/**
 * 门户分页默认配置数据
 */
export const home = [
  {
    separatorType: "icon",
    iconWidth: 16,
    iconType: "icon",
    iconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    iconMargin: 5,
    iconColor: "rgba(0, 0, 0, 0.2)",
    isSystemComponent: true,
    isDefaultComponent: true,
    isCustomComponent: true, //定制组件
    isIndependenceComponent: true ,
  },
  {
    styleId: 2,
    isSystemComponent: true,
    isDefaultComponent: true,
    isCustomComponent: true, //定制组件
    isIndependenceComponent: true ,
  },
]

/**
 * 大屏分页默认配置数据
 */
export const bs = [
  {},
]

/**
 * app分页默认配置数据
 */
export const appHome = [
  {
    isSystemComponent: true,
    isDefaultComponent: true,
    isCustomComponent: true, //定制组件
    isIndependenceComponent: true ,
  },
]